export const pagination = {
    data () {
      return {
        pagination: {
          pageNum: 1,
          pageSizes: [50, 100, 150, 200],
          pageSize: 50,
          total: 0,
          layout: 'total, prev, pager, next, sizes'
        }
      }
    }
  }


export const industryList = {
  data () {
    return {
      industryList: [
        'IT/互联网',
        '金融业',
        '房地产业/建筑业',
        '商务服务业',
        '生活服务业',
        '文化/传媒/广告',
        '快速消费品',
        '耐用消费品',
        '制造业',
        '汽车制造/维修/零配件',
        '通信/电子/半导体',
        '贸易/批发/零售',
        '医疗/医药',
        '教育/培训/科研',
        '能源/矿产/电力',
        '交通/物流/仓储',
        '农林牧渔',
        '政府/机构/组织',
      ]
    }
  }
}
